import { Modal } from '@/components/widgets/modal';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { usePlayerSurveyIsSubmitted } from '@/hooks/query/use-player-survey';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { isDesktop } from 'react-device-detect';
import '@/styles/events/survey/index.scss';


export const SurveyPopup = () => {
	const t = useTranslations('General');
	const { isSubmitted } = usePlayerSurveyIsSubmitted();
	const [isShow, setIsShow] = useState(false);

	useEffect(() => {
		const hasClosed = localStorage.getItem('close-player-survey-popup') === 'true';
		const needShowPopup = isSubmitted === false && !hasClosed; // 沒送出過問卷 & 沒顯示過popup
		if (needShowPopup) {
			setIsShow(true);
		}
	}, [isSubmitted]);

	const closePopup = () => {
		setIsShow(false);
		localStorage.setItem('close-player-survey-popup', 'true');
	}

	const openSurveyForm = () => {
		setIsShow(false);
		localStorage.setItem('close-player-survey-popup', 'true');
		
		// 202405 已棄用 GalaxyV1, 若欲重開此功能請重新設計埋點
		// const kafkaData = {
		// 	type: 10,
		// 	action: isDesktop? 6: 3,
		// }
		// setKafkaNormal(kafkaData);
		
		document.dispatchEvent(new CustomEvent('show-player-survey-form', {}));
	}

	return (
		<Modal
			variant="event"
			isOpen={isShow}
			closeModal={closePopup}
			showHeader={false}
			isBackdropClose={false}
		>
			<div className="survey-popup" data-open={isShow}>
				<div className="survey-popup__events">
					<div className="survey-popup__container">
						<i className="survey-popup__icon-close"
							onClick={closePopup}
						>
						</i>
						<div className="survey-popup__kv"></div>
						<div className="survey-popup__content">
							<div className="survey-popup__box">
								<div className="survey-popup__title">
									<span dangerouslySetInnerHTML={{ __html: t.raw('lbl_SabaSurvey1min02') }}></span>
								</div>
								<div className="survey-popup__btn"
									onClick={openSurveyForm}
								>
									{t('lbl_SabaSurveyReplyNow')}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};